// Document status VALUES — must match the backend canonical taxonomy
// (app/models/document_taxonomy.py DOCUMENT_STATUS) exactly, since the server
// matches by string equality and normalizes unknown values away.
export const selectOptionsDocumentStatus = [
  "New Upload",
  "Pending Review",
  "Processor Reviewed",
  "Incomplete",
  "Rejected",
  "Accepted",
];

// Display labels — the stored VALUE stays the canonical string above, but some
// statuses read differently in the UI. Only labels differ; values never do.
export const DOCUMENT_STATUS_LABELS = {
  Accepted: "Underwriter Accepted",
};

// Resolve a status value to its display label (value passes through unchanged
// when there's no override). Use this wherever a documentStatus is shown.
export const documentStatusLabel = (status) =>
  DOCUMENT_STATUS_LABELS[status] || status || "";

// `{ value, label }` form for selects/dropdowns that render a display label
// distinct from the persisted value. Value stays canonical; label is friendly.
export const selectOptionsDocumentStatusWithLabels =
  selectOptionsDocumentStatus.map((value) => ({
    value,
    label: documentStatusLabel(value),
  }));
